module.exports = __webpack_public_path__ + "img/icon5.345db2bb.svg";